module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"buyBackTitle":"USDT充值码","addressNotYet":"暂未生成","addressCommited":"已提交，等待生成新的充值码。","addressGen":"USDT充值码已生成。"},"zn":{"buyBackTitle":"USDT充值码","addressNotYet":"暂未生成","addressCommited":"已提交，等待生成新的充值码。","addressGen":"USDT充值码已生成。"}}')
  delete Component.options._Ctor
}
